import P from 'prop-types';

// eslint-disable-next-line no-unused-vars
export const DesvinculaPerfil = ({ idToken, idCarga }) => {
  return (
    <>
      <button className="btn btn-secondary">Desvincular Token</button>
    </>
  );
};

DesvinculaPerfil.propTypes = {
  idToken: P.number,
  idCarga: P.number,
};
